module.exports = __webpack_public_path__ + "img/0bbd870.svg";